(() => {
  const version = 1;
  const prefix = 'optimumForm';

  function id() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function key(formName) {
    return `${prefix}:v${version}:${formName}`;
  }

  function read(formName) {
    try {
      const value = JSON.parse(sessionStorage.getItem(key(formName)) || 'null');
      return value?.version === version && value?.id ? value : { version, id: id(), data: {} };
    } catch {
      return { version, id: id(), data: {} };
    }
  }

  function write(formName, value) {
    sessionStorage.setItem(key(formName), JSON.stringify(value));
  }

  window.OptimumFormState = {
    create(formName) {
      let state = read(formName);
      write(formName, state);

      return {
        get id() {
          return state.id;
        },
        load() {
          state = read(formName);
          return state.data || {};
        },
        save(data) {
          state = { version, id: state.id, data };
          write(formName, state);
          return data;
        },
        replace({ id: replacementId, data }) {
          if (!replacementId) throw new Error('Form state replacement requires an id');
          state = { version, id: replacementId, data };
          write(formName, state);
          return state.data;
        },
        clear() {
          sessionStorage.removeItem(key(formName));
          state = { version, id: id(), data: {} };
          write(formName, state);
          return true;
        },
      };
    },
  };
})();
